import { Pause, Play } from "lucide-react"
import { useEffect, useState } from "react"

import { LogbookIllustration } from "./product-art"

const WEEKS = 12
const STEP_MS = 900

/**
 * Looping 12-week logbook demo (T399-2): the strip fills week by week. Motion has a pause control
 * (web-landing rule) and starts paused on week 4, the static frame, when the visitor prefers reduced motion.
 */
export const LogbookTimelineDemo = () => {
  const [week, setWeek] = useState(4)
  const [playing, setPlaying] = useState(false)

  useEffect(() => {
    const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
    if (!reduce) setPlaying(true)
  }, [])

  useEffect(() => {
    if (!playing) return
    const id = setInterval(() => setWeek((w) => (w % WEEKS) + 1), STEP_MS)
    return () => clearInterval(id)
  }, [playing])

  return (
    <div className="grid gap-2">
      <div
        role="img"
        aria-label={`Logbook demo: week ${week} of ${WEEKS}. The 12-week logbook fills week by week.`}
      >
        <LogbookIllustration week={week} />
      </div>
      <button
        type="button"
        onClick={() => setPlaying((p) => !p)}
        aria-label={playing ? "Pause animation" : "Play animation"}
        className="text-muted-foreground hover:text-foreground focus-visible:ring-ring inline-flex min-h-11 items-center gap-2 justify-self-center rounded-md px-3 text-sm outline-none focus-visible:ring-2"
      >
        {playing ? (
          <Pause className="size-4" aria-hidden="true" />
        ) : (
          <Play className="size-4" aria-hidden="true" />
        )}
        {playing ? "Pause" : "Play"}
      </button>
    </div>
  )
}
